module.exports = window["wp"]["api"];